import { Stack } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardCategorySectionHeader } from "web_myplann/Dashboard/Components/DashboardCategorySectionHeader";
import { DashboardDetailRow } from "web_myplann/Dashboard/Components/DashboardDetailRow";
import type { DashboardCategorySectionData } from "web_myplann/Dashboard/Hooks/useDashboardTotalSections";

type Props = {
	section: DashboardCategorySectionData;
};

export const DashboardCategorySection: FC<Props> = ({ section }) => {
	const navigate = useNavigate();

	return (
		<Stack bgcolor="background.paper">
			<DashboardCategorySectionHeader
				title={section.title}
				subtotalText={section.subtotalText}
				onClick={() => navigate(section.navigateTo)}
			/>

			{section.rows.map((row, index) => (
				<DashboardDetailRow
					key={row.id}
					row={row}
					isLast={index === section.rows.length - 1}
					onClick={() => navigate(row.navigateTo)}
				/>
			))}
		</Stack>
	);
};
